import React from 'react'
import Link from 'gatsby-link'
import classnames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import SvgIcon from '@material-ui/core/SvgIcon'
import ListItemText from '@material-ui/core/ListItemText'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import { fragStudies, fragStudy } from '../utils/fragments'
import { mapStudy, mapStudies, mapMetaData } from '../utils/mapper'

import styles from '../styles/site'

import StudyIcon from '../img/icons/study.svg'

import MetaData from '../components/metadata'
import Banner from '../components/banner'
import Quote from '../components/quote'
import Footer from '../components/footer'

const StudiesPage = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.studies)
  const studies = mapStudies(props.data.studies)

  const all = props.data.all.edges.map(study => {
    return mapStudy(study.node)
  })

  console.dir(all)

  return (
    <div>
      <MetaData data={metadata} />
      <Banner uid="studies" title={studies.title} subtitle={studies.subtitle} />
      <Teaser image={studies.featured_bg} />
      <Focus study={studies.featured_study} />
      {studies.list.map((study, index) => {
        return (
          <div key={index}>
            <Content study={study} />
          </div>
        )
      })}
      <StudyNav all={all} featured={studies.list} />
      <Footer policies={props.data.policies.edges} />
    </div>
  )
}

const Teaser = withStyles(styles)(props => {
  const { classes, image } = props
  return (
    <div className={classes.teaser}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <div
            style={{
              background: `url(${image.src})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              height: '40vh',
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
})

const Focus = withStyles(styles)(props => {
  const { classes, study } = props
  let LinkButton = props => <Link to={`/study/${study.uid}`} {...props} />
  return (
    <div className={classes.focus}>
      <div className={classes.contents}>
        <Hidden xsDown>
          <div className={classnames(classes.focusFloat)}>
            {study.data.customer && (
              <img
                src={
                  study.data.customer.document[0].data.logo.localFile
                    .childImageSharp.original.src
                }
                style={{
                  display: 'inline',
                  background: '#00a9e4',
                  height: 150,
                  marginLeft: '-5.5rem',
                  marginTop: '-2rem',
                  marginBottom: '2rem',
                  boxShadow: '10px 10px 5px 0px rgba(0,0,0,0.5)',
                }}
              />
            )}
            <div className={classes.focusFloatStudies}>
              <Grid container spacing={0} className={classes.focusText}>
                <Grid item xs={12}>
                  <Typography className={classes.focusSub} gutterBottom>
                    {study.data.title.text}
                  </Typography>
                  <Typography className={classes.focusText}>
                    {study.data.lead.text}
                  </Typography>
                  <Button
                    component={LinkButton}
                    className={classnames(
                      // classes.studylistLink,
                      classes.focusLink
                    )}
                  >
                    Read more
                    {/* <ChevronRight className={classes.rightIcon} /> */}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </Hidden>
      </div>
    </div>
  )
})

const Content = props => {
  const { study } = props
  return study.type === 'study_list' ? (
    <StudyList studies={study.contents} />
  ) : study.type === 'study_quote' ? (
    <Quote quote={study.quote} />
  ) : null
}

const StudyList = withStyles(styles)(props => {
  const { classes, studies } = props

  return (
    <div className={classes.studyList}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Hidden xsDown>
            <Grid container spacing={16}>
              {studies.map((study, index) => {
                return (
                  <Grid key={index} item xs={6}>
                    <Study study={study} classes={classes} />
                  </Grid>
                )
              })}
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Grid container>
              <Grid item xs={12}>
                {studies.map((study, index) => {
                  return <Study key={index} study={study} classes={classes} />
                })}
              </Grid>
            </Grid>
          </Hidden>
        </div>
      </div>
    </div>
  )
})

const Study = props => {
  const { classes, study, index } = props

  console.log('STUDY', study)

  let LinkButton = props => <Link to={`/study/${study.uid}`} {...props} />
  return (
    <div key={index} className={classes.studies}>
      <Grid container spacing={40} className={classes.studyItem}>
        <Grid item xs={12}>
          <div
            style={{
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              background: '#00a9e4',
              padding: '.5rem',
              justifyContent: 'center'
            }}
          >

            {/* <Typography
              variant="subheading"
              gutterBottom
              style={{
                color: '#fff',
                margin: 0,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {study.customer ? study.customer.title.text : ''}

            </Typography> */}

            {study.customer && (
              <img
                src={study.customer.logo.localFile.childImageSharp.original.src}
                style={{ height: 40}}
              />
            )}


          </div>

          <div
            className={classes.studyThumbnail}
            style={{ backgroundImage: `url(${study.study_bg.src})` }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="title" gutterBottom>
            {study.title.text}
          </Typography>
          <Typography variant="caption">{study.published}</Typography>
          <Typography className={classes.studylistText}>
            {study.lead.text}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button component={LinkButton} className={classes.studylistLink}>
            Read more
            {/* <ChevronRight className={classes.rightIcon} /> */}
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

const StudyNav = withStyles(styles)(props => {
  const { all, featured, classes } = props
  return (
    <div className={classes.blogStudyNavItems}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container spacing={40}>
            <Grid item className={classes.title}>
              <Typography
                variant="headline"
                className={classes.blogStudyNavTitle}
              >
                All Client Studies
              </Typography>
              {all.map(item => {
                let active = false
                featured.map(list => {
                  if (list.type === 'blog_list') {
                    list.contents.find(x => {
                      if (x.uid === item.uid) {
                        active = true
                      }
                    })
                  }
                })
                return (
                  <ListItem
                    key={item.uid}
                    button
                    component={Link}
                    to={`/study/${item.uid}`}
                  >
                    <img src={StudyIcon} className={classes.blogStudyNavIcon} />
                    <ListItemText
                      primary={item.title.text}
                      secondary={item.published}
                      classes={{
                        primary: classes.blogStudyItemHead,
                        secondary: classes.blogStudyItemSub,
                      }}
                    />
                  </ListItem>
                )
              })}
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(StudiesPage)

export const query = graphql`
  query studiesQuery {
    studies: prismicCtStudies {
      ...studies
    }
    all: allPrismicCtStudy(filter: { tags: { regex: "/^((?!test).)*$/" } }) {
      edges {
        node {
          ...study
        }
      }
    }
    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/studies.js